<template>
    <div class="flex_content">

        <div id="context_bar">
            <TopbarGoPositionsList />
        </div>

        <titlePage>
            <template slot="titleBody">
                <h1 class="page-title title is-size-1" v-if="currentPosition">{{ currentPosition.name }}</h1>
                <h2 class="associated_ref_name" v-if="currentRef"><span>{{ refName }}</span></h2>
            </template>
        </titlePage>

        
        <nav v-if="candidatesTotalPages > 1" class="pagination table-pagination is-centered is-medium position_evals_pagination">
            <paginate
                :page-count="candidatesTotalPages"
                :click-handler="OnPageChange"
                :prev-text="'<'"
                :next-text="'>'"
                :page-link-class="'pagination-link'"
                :active-class="'is-current'"
                :prev-link-class="'pagination-link'"
                :next-link-class="'pagination-link'"
                :disabled-class="'is-disabled'"
                :container-class="'pagination-list'">
            </paginate>
        </nav>
        <div v-if="currentPosition && dimensionsPlan">
            <div class="eval_tabs">
                <BtnTab btn-id="PostitionEvalsGeneralTab" :active-tab="currentTab == 'PostitionEvalsGeneralTab'" @btnTab:Clicked="changeTab">
                    {{ $t('modules.positions.evals_detail.generalTab') }}
                </BtnTab>
                <BtnTab btn-id="PostitionEvalsSkillsTab" :active-tab="currentTab == 'PostitionEvalsSkillsTab'" @btnTab:Clicked="changeTab" v-if="dimensionsPlan.show_soft_skills">
                    {{ dimensionsPlan.soft_skills_title[$i18n.locale] }}
                </BtnTab>
                <BtnTab btn-id="PostitionEvalsRespectTab" :active-tab="currentTab == 'PostitionEvalsRespectTab'" @btnTab:Clicked="changeTab" v-if="dimensionsPlan.show_respect2">
                    {{ $t('modules.evaluations.edit.respectTab') }}
                </BtnTab>
                <BtnTab btn-id="PostitionCustomSkillsTab" :active-tab="currentTab == 'PostitionCustomSkillsTab'" @btnTab:Clicked="changeTab" v-if="dimensionsPlan.show_custom_skills">
                    {{ dimensionsPlan.custom_skills_title[$i18n.locale] }}
                </BtnTab>
                <BtnTab btn-id="PostitionEvalsAgilityTab" :active-tab="currentTab == 'PostitionEvalsAgilityTab'" @btnTab:Clicked="changeTab" v-if="dimensionsPlan.show_agilities">
                    {{ $t('modules.positions.evals_detail.agilitiesTab') }}
                </BtnTab>
                <BtnTab btn-id="PostitionEvalsStrengthTab" :active-tab="currentTab == 'PostitionEvalsStrengthTab'" @btnTab:Clicked="changeTab" v-if="dimensionsPlan.show_strengths">
                    {{ $t('modules.positions.evals_detail.strengthsTab') }}
                </BtnTab>
                <BtnTab btn-id="PostitionEvalsStrengthCustomTab" :active-tab="currentTab == 'PostitionEvalsStrengthCustomTab'" @btnTab:Clicked="changeTab" v-if="dimensionsPlan.show_strengths_custom">
                    {{ dimensionsPlan.strenghts_custom_title[$i18n.locale]}}
                </BtnTab>
                
                <BtnTab btn-id="PostitionEvalsGameRulesTab" :active-tab="currentTab == 'PostitionEvalsGameRulesTab'" @btnTab:Clicked="changeTab" v-if="dimensionsPlan.show_game_rules">
                    {{ $t('modules.positions.evals_detail.gameRulesTab') }}
                </BtnTab>
            </div>

            <div class="tabs_content" v-if="dataLoaded">

                <transition name="survey-fade">
                    <component :is="currentTab"
                        :dataLoaded="dataLoaded"
                        :currentPosition="currentPosition"
                        :evaluations="evaluations"
                        :currentRef="currentRef"
                        :selectedPositionEvals="selectedPositionEvals"
                        @SelectionCheckBoxClicked="onCheckBoxClicked"
                        @reorderEval="reorderEval"  >
                    </component>
                </transition>

            </div>


            <nav v-if="candidatesTotalPages > 1" class="pagination table-pagination is-centered is-medium position_evals_pagination_bottom">
                <paginate
                    :page-count="candidatesTotalPages"
                    :click-handler="OnPageChange"
                    :prev-text="'<'"
                    :next-text="'>'"
                    :page-link-class="'pagination-link'"
                    :active-class="'is-current'"
                    :prev-link-class="'pagination-link'"
                    :next-link-class="'pagination-link'"
                    :disabled-class="'is-disabled'"
                    :container-class="'pagination-list'">
                </paginate>
            </nav>
        </div>

        <transition name="notif-slide-up">
            <alert v-if="addSendReportNotif" context="danger" @close="addSendReportNotif=false">{{ $t('modules.positions.evals_detail.alertTooMuchEvalsSelected') }}</alert>
        </transition>

    </div>

</template>

<script>
import TitlePage from "@/components/layouts/titlePage"
import TopbarGoPositionsList from "../components/topbar/topbarGoPositionsList"

import PostitionEvalsSkillsTab from "../components/evaluations/skillsTab"
import PostitionEvalsAgilityTab from "../components/evaluations/agilityTab"
import PostitionEvalsStrengthTab from "../components/evaluations/strengthTab"
import PostitionEvalsStrengthCustomTab from "../components/evaluations/strengthCustomTab"

import PostitionEvalsGeneralTab from "../components/evaluations/generalTab"
import PostitionCustomSkillsTab from "../components/evaluations/customSkillsTab"
import PostitionEvalsRespectTab from "../components/evaluations/respectTab"
import PostitionEvalsGameRulesTab from "../components/evaluations/gameRulesTab"


export default {
    name: 'PositionEvaluations',
    components: {
        TitlePage,
        TopbarGoPositionsList,
        PostitionEvalsSkillsTab,
        PostitionEvalsAgilityTab,
        PostitionEvalsStrengthTab,
        PostitionEvalsGeneralTab,
        PostitionCustomSkillsTab,
        PostitionEvalsRespectTab,
        PostitionEvalsGameRulesTab,
        PostitionEvalsStrengthCustomTab
    },
    created(){
        this.$store.dispatch('PositionStore/getPosition', this.$route.params.id).then(() => {
            this.$store.dispatch('PositionStore/initPositionEvals', this.$route.params.id)
            this.updateEvaluationsList()
        })
    },
    data(){
        return {
            currentTab: 'PostitionEvalsGeneralTab',
            sort_type: 'ASC',
            targetPage: 1,
            sorting_column: "created_at",
            dataLoaded: false,
            addSendReportNotif: false
        }
    },
    computed: {
        currentPosition(){
            return this.$store.state.PositionStore.currentPosition
        },
        dimensionsPlan(){
            return this.currentPosition.dimensions_plan
        },
        evaluations(){
            return this.$store.state.PositionStore.PositionEvals
        },
        currentRef(){
            return this.currentPosition.sight_ref
        },
        refName(){
            if(this.currentRef){
                return this.currentRef.job_titles[this.$i18n.locale]
            }else{
                return ""
            }
        },
        candidatesCurrentPage(){
            return this.$store.state.PositionStore.candidatesCurrentPage
        },
        candidatesTotalPages(){
            return this.$store.state.PositionStore.candidatesTotalPages
        },
        candidatesItemPerPage(){
            return this.$store.state.PositionStore.candidatesItemPerPage
        },
        selectedPositionEvals(){
            return this.$store.state.PositionStore.SelectedPositionEvalsIds
        }
    },
    methods: {

        onCheckBoxClicked(data){
            if(!data.isChecked || this.selectedPositionEvals.length < 3){
                this.$store.dispatch('PositionStore/updateEvalsSelection', data)
            }else{
                this.addSendReportNotif = true
            }
        },
        changeTab(tabName){
            this.dataLoaded = false
            this.currentTab = tabName
            this.updateEvaluationsList()
        },
        toggleSortingType(){
            this.sort_type == 'ASC' ? this.sort_type = 'DESC' : this.sort_type = 'ASC'
        },
        reorderEval(column){
            if (this.sorting_column == column){
                this.toggleSortingType()
            }else{
                this.sorting_column = column
                this.sort_type == 'ASC'
            }
            this.updateEvaluationsList()
        },
        OnPageChange(targetpage){
            this.dataLoaded = false
            this.targetPage = targetpage
            this.updateEvaluationsList()
        },
        updateEvaluationsList(){
            var onlyCompleted = (this.currentTab == 'PostitionEvalsGeneralTab') ? 0 : 1
            const queryData = {
            position_id: this.currentPosition.id,
            sort_column: this.sorting_column,
            sort_type: this.sort_type,
            only_completed: onlyCompleted,
            current_page: this.targetPage,
            item_per_page: this.candidatesItemPerPage }
            this.$store.dispatch('PositionStore/getPositionEvals', queryData).then(err => {
                setTimeout(() => { this.dataLoaded = true }, 50)
            })
        }
    }
}
</script>

<style lang="scss" >
#index_eval_content{
    background: $white;
}
.eval_tabs{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: stretch;
    background-color: $white;
}
.position_evals_pagination{
    background: white;
}
.tabs_content{
    padding-bottom: 20px;
}
.evaluations_loader_container{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 50px;
    .evaluations_loader{
        width: 50px;
        fill: $info;
    }
}
.show_compare_chart_container{
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
}
</style>
